import React from 'react';
import { useAppTheme } from '../../lib/appTheme';
import { Bat, Cobweb, Pumpkin, Spider } from './halloweenArt';
import './seasonal.css';

const HalloweenDecorations = () => (
  <>
    <Cobweb className="sd-web sd-web-tl" />
    <Cobweb className="sd-web sd-web-tr" />
    <span className="sd-crawler" data-testid="seasonal-spider">
      <span className="sd-drop">
        <span className="sd-thread" />
        <Spider className="sd-spider-art" />
      </span>
    </span>
    <span className="sd-pumpkins" data-testid="seasonal-pumpkins">
      <Pumpkin className="sd-pumpkin" face />
      <Pumpkin className="sd-pumpkin sd-pumpkin-sm" />
    </span>
    <Bat className="sd-bat" />
  </>
);

// Decoration packages are app-level and independent from the selected theme.
const PACKAGES = { halloween: HalloweenDecorations };

export const SeasonalDecorations = () => {
  const { season } = useAppTheme();
  const Pkg = season && PACKAGES[season.decorations];
  if (!Pkg) return null;
  return (
    <div className={`sd-layer sd-${season.decorations}`} aria-hidden="true" data-testid="seasonal-decorations" data-season={season.key}>
      <Pkg />
    </div>
  );
};

export default SeasonalDecorations;
